import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaClipboardList } from "react-icons/fa";
import axios from "axios";
import useAuth from "../dashboard/useAuth";
import Sidebar from "../dashboard/sidebar";
import Navbar from "../dashboard/navbar";

const Transaction = ({ titre }) => {
    useAuth();
    const [achats, setAchats] = useState([]);
    const [selectedAchat, setSelectedAchat] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: "date_achat", direction: "descending" });
    const [searchTerm, setSearchTerm] = useState("");
    const [filtreStatut, setFiltreStatut] = useState("tous");
    const [alert, setAlert] = useState({ message: "", type: "" });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [accesGroupe, setAccesGroupe] = useState([]);
    const user_id = localStorage.getItem("IDDDD");

    useEffect(() => {
        if (user_id) {
            document.title = "PayMe | Historique des transactions";
            verifGroupe();
            fetchAchats();
        }
    }, [user_id]);

    const fetchAchats = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/liste-achats/`);
            console.log("Données reçues:", response.data); // Debug important

            // Vérification approfondie de la structure des données
            let achatsData = [];

            if (Array.isArray(response.data)) {
                achatsData = response.data;
            } else if (response.data && typeof response.data === 'object') {
                // Si c'est un objet, essayons d'extraire les achats
                if (response.data.achats && Array.isArray(response.data.achats)) {
                    achatsData = response.data.achats;
                } else {
                    // Essayons de convertir l'objet en tableau
                    achatsData = Object.values(response.data);
                }
            }

            if (achatsData.length > 0) {
                setAchats(achatsData);
            } else {
                console.error("Aucune donnée d'achat valide trouvée");
                setAchats([]);
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            setAchats([]);
            showAlert("Erreur lors du chargement des achats", "danger");
        }
    };

    const verifGroupe = async () => {
        const groupe = localStorage.getItem("groupe");
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
            if (response.status === 200) {
                const cleanedAccessArray = response.data.acces
                    .map(item => item.acces ? item.acces.replace(/[\[\]']/g, "").trim().split(",").map(access => access.trim()) : [])
                    .flat();
                setAccesGroupe(cleanedAccessArray);
                localStorage.setItem("accesGroupe", JSON.stringify(cleanedAccessArray));
            }
        } catch (error) {
            console.error('Erreur lors de la vérification du groupe', error);
        }
    };

    if (!accesGroupe.includes("Transactions")) {
        return null;
    }

    const handleDeleteAchat = async () => {
        if (selectedAchat) {
            try {
                await axios.delete(`${process.env.REACT_APP_HOTE}/supprimer-achat/${selectedAchat.achat_id}/`);
                showAlert("Achat supprimé avec succès !");
                fetchAchats();
            } catch (error) {
                console.error("Erreur lors de la suppression", error);
                showAlert("Erreur lors de la suppression", "danger");
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const showAlert = (message, type = "success") => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: "", type: "" }), 3000);
    };

    const handleSort = (key) => {
        setSortConfig({
            key,
            direction: sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending"
        });
    };

    const filteredAchats = achats.filter(achat => {
        const matchesSearch =
            achat.nom_utilisateur.toLowerCase().includes(searchTerm.toLowerCase()) ||
            achat.nom_produit.toLowerCase().includes(searchTerm.toLowerCase()) ||
            achat.transaction_id.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = filtreStatut === "tous" || achat.status === filtreStatut;

        return matchesSearch && matchesStatus;
    });

    const sortedAchats = [...filteredAchats].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    const indexOfLastAchat = currentPage * itemsPerPage;
    const indexOfFirstAchat = indexOfLastAchat - itemsPerPage;
    const currentAchats = sortedAchats.slice(indexOfFirstAchat, indexOfLastAchat);
    const totalPages = Math.ceil(sortedAchats.length / itemsPerPage);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(amount);
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className="d-flex align-items-center">
                            <FaClipboardList size={25} className="mr-2" /> Historique des transactions
                        </h2>
                        <small>Administration des transactions.</small>
                    </div>
                </div>

                <div className="mt-3">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                        <h5>Liste des transactions</h5>
                        <div className="d-flex flex-column flex-sm-row flex-wrap mt-3 mt-md-0" style={{ gap: "10px" }}>
                            <div className="d-flex">
                                <button className="btn btn-success mr-2">
                                    <FaPlus /> Exporter
                                </button>
                            </div>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type}`}>{alert.message}</div>
                    )}

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: "10px" }}>
                                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                            <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    setItemsPerPage(Number(e.target.value));
                                                    setCurrentPage(1);
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                            </select>

                                            {/* <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={filtreStatut}
                                                onChange={(e) => setFiltreStatut(e.target.value)}
                                            >
                                                <option value="tous">Tous les statuts</option>
                                                <option value="Terminé">Terminé</option>
                                                <option value="Échoué">Échoué</option>
                                                <option value="En attente">En attente</option>
                                            </select> */}
                                        </div>

                                        <input
                                            type="text"
                                            placeholder="Rechercher..."
                                            className="form-control"
                                            style={{ maxWidth: "150px", width: "100%" }}
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>

                                    <div className="table-responsive">
                                        <table
                                            className="footable table table-stripped footable-loaded tablet breakpoint"
                                            data-page-size="8"
                                            data-filter="#filter"
                                            style={{ fontSize: "12px" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell"
                                                        onClick={() => handleSort("transaction_id")}
                                                        style={{ width: "10%", minWidth: "100px" }}
                                                    >
                                                        Transaction
                                                        {sortConfig.key === "transaction_id" &&
                                                            (sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell  align-middle"
                                                        onClick={() => handleSort("nom_utilisateur")}
                                                        style={{ width: "15%", minWidth: "150px" }}
                                                    >
                                                        Client
                                                        {sortConfig.key === "nom_utilisateur" &&
                                                            (sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell  align-middle"
                                                        onClick={() => handleSort("nom_produit")}
                                                        style={{ width: "12%", minWidth: "80px" }}
                                                    >
                                                        Produit
                                                        {sortConfig.key === "nom_produit" &&
                                                            (sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center  align-middle"
                                                        onClick={() => handleSort("prix_unitaire")}
                                                        style={{ width: "15%", minWidth: "80px" }}
                                                    >
                                                        Prix unitaire
                                                        {sortConfig.key === "prix_unitaire" &&
                                                            (sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("quantite")}
                                                        style={{ width: "10%", minWidth: "70px" }}
                                                    >
                                                        Quantité
                                                        {sortConfig.key === "quantite" &&
                                                            (sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("total")}
                                                        style={{ width: "10%", minWidth: "80px" }}
                                                    >
                                                        Total
                                                        {sortConfig.key === "total" &&
                                                            (sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("mode_paiement")}
                                                        style={{ width: "12%", minWidth: "100px" }}
                                                    >
                                                        Paiement
                                                        {sortConfig.key === "mode_paiement" &&
                                                            (sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell"
                                                        onClick={() => handleSort("date_achat")}
                                                        style={{ width: "15%", minWidth: "100px" }}
                                                    >
                                                        Date
                                                        {sortConfig.key === "date_achat" &&
                                                            (sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    {/* <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("status")}
                                                        style={{ width: "10%", minWidth: "80px" }}
                                                    >
                                                        Statut
                                                        {sortConfig.key === "status" &&
                                                            (sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentAchats && currentAchats.length > 0 ? (
                                                    currentAchats.map((achat) => (
                                                        <tr
                                                            key={achat.achat_id}
                                                            onClick={() => setSelectedAchat(achat)}
                                                            className={`bg-white ${selectedAchat?.achat_id === achat.achat_id ? "bg-success text-white" : ""}`}
                                                        >
                                                            <td style={{ padding: "0.5rem" }}>
                                                                <div className="fw-semibold">{achat.transaction_id}</div>
                                                            </td>
                                                            <td className="" style={{ padding: "0.5rem" }}>
                                                                <div className="fw-semibold">{achat.nom_utilisateur}</div>
                                                            </td>
                                                            <td
                                                                className=""
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="text-dark">{achat.nom_produit}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{formatCurrency(achat.prix_unitaire)}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{achat.quantite}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{formatCurrency(achat.total)}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span>{achat.mode_paiement}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span>{achat.date_achat}</span>
                                                            </td>
                                                            {/* <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className={`badge ${achat.status === 'completed' ? 'bg-primary' :
                                                                    achat.status === 'Échoué' ? 'bg-danger' : 'bg-warning'
                                                                    }`}>
                                                                    {achat.status}
                                                                </span>
                                                            </td> */}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">
                                                            Aucun achat trouvé
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination Controls */}
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="dataTables_info" role="status" aria-live="polite">
                                            {sortedAchats.length === 0
                                                ? "Aucun élément à afficher"
                                                : `Élément ${indexOfFirstAchat + 1} à ${Math.min(indexOfLastAchat, sortedAchats.length)} sur ${sortedAchats.length}`}
                                        </div>

                                        <div>
                                            {Array.from({ length: totalPages }, (_, index) => (
                                                <button
                                                    key={index + 1}
                                                    onClick={() => setCurrentPage(index + 1)}
                                                    className={`btn ${currentPage === index + 1 ? "btn-default" : "btn-light"
                                                        } mx-1`}
                                                >
                                                    {index + 1}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Détails de l'achat sélectionné */}
                    {selectedAchat && (
                        <div className="card mt-4">
                            <div className="card-header bg-primary text-white">
                                <h5>Détails de l'achat #{selectedAchat.transaction_id}</h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <p><strong>🧾 Transaction:</strong> #{selectedAchat.transaction_id}</p>
                                        <p><strong>👤 Client:</strong> {selectedAchat.nom_utilisateur}</p>
                                        <p><strong>📦 Produit:</strong> {selectedAchat.nom_produit}</p>
                                        <p><strong>🔢 Quantité:</strong> {selectedAchat.quantite}</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><strong>💰 Prix unitaire:</strong> {formatCurrency(selectedAchat.prix_unitaire)}</p>
                                        <p><strong>💵 Total:</strong> {formatCurrency(selectedAchat.total)}</p>
                                        <p><strong>💳 Paiement:</strong> {selectedAchat.mode_paiement}</p>
                                        <p><strong>📅 Date:</strong> {selectedAchat.date_achat}</p>
                                        <p><strong>📌 Statut:</strong>
                                            <span className={`badge ms-2 ${selectedAchat.status === 'Terminé' ? 'bg-success' :
                                                selectedAchat.status === 'Échoué' ? 'bg-danger' : 'bg-warning'
                                                }`}>
                                                {selectedAchat.status}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <button
                                        className="btn btn-danger me-2"
                                        onClick={() => setShowDeleteModal(true)}
                                    >
                                        <FaTrash /> Supprimer
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Modal de suppression */}
                    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmer la suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer l'achat #{selectedAchat?.transaction_id} ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                                Annuler
                            </Button>
                            <Button variant="danger" onClick={handleDeleteAchat}>
                                Supprimer
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default Transaction;